import { useDocumentTitle } from "../../common/utils/hooks/useDocumentTitle";
import { Ewr } from "./Ewr";

export const Reports = () => {
	const pageName = "Exopen Web Reports";
	useDocumentTitle(pageName);

	return <Ewr />;
};
